/**
 * 分类
 */
import CommonApi from 'api/common.js';
var url = '/dayaotex-server-goods';
var AccountApi = {
  // app前台推荐列表
  priceAnalysePage: function priceAnalysePage(data) {
    return CommonApi.post(url + '/priceAnalyse/priceAnalysePage', data);
  },
  getGoodsPriceHistory: function getGoodsPriceHistory(data) {
    console.log(data);
    return CommonApi.post(url + '/priceHistory/selectHistoryBetweenDate', data);
  }
};
export default AccountApi;